import { Link } from "react-router-dom";
import { useInView } from "@/hooks/useInView";
import { cn } from "@/lib/utils";

export const LandingEndCta = () => {
  const { ref, isInView } = useInView({ threshold: 0.25 });

  return (
    <div
      ref={ref}
      className={cn(
        "mt-16 pt-10 md:mt-20 md:pt-12",
        "transition-all duration-700",
        isInView ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0",
      )}
      aria-labelledby="landing-end-cta-heading"
    >
      <div className="flex flex-col items-stretch gap-6 sm:flex-row sm:items-center sm:gap-8">
        <div
          className="hidden min-w-0 flex-1 border-t border-dashed border-[#d4b4b4] sm:block"
          aria-hidden
        />

        <p
          id="landing-end-cta-heading"
          className="shrink-0 text-center text-lg font-medium tracking-tight text-foreground sm:text-left md:text-xl"
        >
          Pronto para criar seu primeiro agente de IA?
        </p>

        <Link
          to="/auth?tab=signup"
          className={cn(
            "inline-flex shrink-0 items-center justify-center self-center rounded-full px-8 py-3 text-sm font-semibold text-primary-foreground shadow-md shadow-primary/25 transition-opacity hover:opacity-90 sm:self-auto",
            "bg-gradient-to-b from-primary to-[hsl(262,70%,42%)]",
          )}
        >
          Começar agora
        </Link>
      </div>
    </div>
  );
};
